<!--
 * @Author: LiuXin
 * @Date: 2021-11-26 10:57:54
 * @LastEditors: LiuXin
 * @LastEditTime: 2021-12-29 18:34:04
-->
<template>
  <div class="customize-rule-wrapper w100 h100">
    <div class="rule-header">
      <p class="header-text">{{ showCustomizeRule.mode == 'edit' ? '编辑' : '新建' }}托管规则</p>
    </div>
    <ul class="rule-body w100">
      <li class="rule-module hosting-range">
        <p class="module-title">托管范围</p>
        <div class="module-content">
          <ul class="rule-list">
            <li class="rule-item">
              <a-space>
                <span>媒体渠道</span>
                <a-radio-group v-model:value="options.range.channel" @change="channelChange">
                  <a-radio-button value="GDT">腾讯广告</a-radio-button>
                  <a-radio-button value="TT">巨量引擎</a-radio-button>
                  <a-radio-button value="KS">磁力引擎</a-radio-button>
                </a-radio-group>
              </a-space>
            </li>
            <li class="rule-item">
              <a-space>
                <span>应用层级</span>
                <a-select v-model:value="options.range.level" style="width: 238px" v-bind="levelOptions" @change="levelChange"> </a-select>
              </a-space>
            </li>
            <li class="rule-item all-selected-wrapper">
              <div class="select-filter">
                <a-space>
                  <span>选择产品</span>
                  <SelectMultiple :disabled="selectedProjectList.length == 100" ref="productSelect" @search="searchProduct" @blur="getProductList(null, null, true)" @change="productChange" v-model:value="selectedProjectList" :select-data="selectedProjectList" :select-options="productList" :lazy-load="true" v-model:loadOver="productLoadOver" @toBottom="lazyLoadProduct" :allow-clear="true" mode="multiple" :label-in-value="true" placeholder="请选择产品" :filter-option="false" option-label-prop="label" :max-tag-count="1" :show-arrow="true" :dropdown-match-select-width="false" select-option-value="productCode" select-option-label="product_name" style="width: 238px" />
                </a-space>
                <div v-show="options.range.level.value != 'CP' && selectedProjectList.length">
                  <a-radio-group v-model:value="options.range.levelWhere" @change="levelWhereChange">
                    <a-radio :value="1" style="margin-right: 48px">满足筛选的所有{{ rangeRadioText }}</a-radio>
                    <a-radio :value="2">满足筛选的指定{{ rangeRadioText }}</a-radio>
                  </a-radio-group>
                  <SelectMultiple :disabled="selectedList1.length == 100" v-model:value="selectedList1" :select-data="selectedList1" :select-options="selectData1" show-key="id" :allow-clear="true" mode="multiple" :label-in-value="true" placeholder="请选择账户" v-show="cascaderSelectPlaceholders[1] == '账户'" v-bind="$filterOptions" option-label-prop="label" :max-tag-count="1" :show-arrow="true" :dropdown-match-select-width="false" select-option-value="value" select-option-label="label" style="width: 238px" />
                  <CascaderSelect v-model:selectedList1="selectedList1" v-model:selectedList2="selectedList2" :select-source="[selectData1, selectData2]" @getSecondListData="getSelectData2" style="width: 295px" v-show="'广告 推广计划'.includes(cascaderSelectPlaceholders[1])" :cascader-select-placeholders="cascaderSelectPlaceholders"></CascaderSelect>
                </div>
              </div>
              <div class="all-selected" v-show="selectedProjectList.length">
                <span class="selected-number">
                  已选
                  <span style="color: #197afb">{{ selectedList.length }}</span>
                  个：
                </span>
                <ul class="all-selected-list">
                  <li class="all-selected-item" v-for="(item, index) in selectedList" :key="item">
                    <p class="label">{{ item.label }}</p>
                    <p class="id">id：{{ item.value }}</p>
                    <CloseCircleFilled class="delete-icon" @click="deletSelectItem(index, 1, item)" />
                  </li>
                </ul>
                <span class="clear-all" @click="deletSelectItem(0, 10000)">清空</span>
              </div>
            </li>
          </ul>
        </div>
      </li>
      <li class="rule-module trigger-condition">
        <p class="module-title">触发条件</p>
        <div class="module-content">
          <a-space :size="12" style="margin-bottom: 13px">
            <a-button type="primary" @click="addRuleListItem(options.condition)">新增规则</a-button>
            <caliber v-show="options.range.channel == 'GDT'" style="width: 140px" :selected="options.condition.timeLine" :tjkj-list="tjkjList" @selectItem="onTJKJSelect" tjkj-tips="次留、APP付费等深度行为数据按用户激活的时间显示"></caliber>
          </a-space>
          <ul class="rule-list">
            <li v-for="(rule, index) in options.condition.ruleList" :key="rule" :rule="rule" class="rule-item">
              <RuleConditionItem :options="ruleConditionList" :index="index" :rule="rule" :rule-list="options.condition.ruleList" class="mr12"></RuleConditionItem>
              <DeleteOutlined @click="deleteRuleListItem(options.condition.ruleList, index)" v-show="options.condition.ruleList.length > 1" />
            </li>
            <li class="rule-item line-h32">
              <a-checkbox v-model:checked="options.condition.checkPeriod" @change="options.condition.startTime = options.condition.endTime = undefined">
                <span>设置监测时段</span>
                <span v-show="options.condition.checkPeriod">
                  <a-time-picker v-model:value="options.condition.startTime" value-format="HH:mm" format="HH:mm" class="ml12" style="width: 123px" />
                  <span style="width: 10px; text-align: center; display: inline-block">-</span>
                  <a-time-picker v-model:value="options.condition.endTime" value-format="HH:mm" format="HH:mm" style="width: 123px" />
                </span>
              </a-checkbox>
            </li>
            <li class="rule-item line-h32">
              <a-checkbox v-model:checked="options.condition.checkDate" @change="options.condition.monitoringDate = []">
                <span>设置监测日期</span>
                <a-range-picker v-model:value="options.condition.monitoringDate" value-format="YYYY-MM-DD" v-show="options.condition.checkDate" class="w256 ml12" />
              </a-checkbox>
            </li>
            <li class="rule-item">
              <a-radio-group v-model:value="options.condition.hitModel" class="radio-group" @change="options.condition.hitInterval = undefined">
                <a-radio value="NOT">不限当日命中次数</a-radio>
                <a-radio value="ONE">仅当日首次命中</a-radio>
                <a-radio value="ERVERTIME">
                  <a-space><span>当首日命中后，间隔</span><a-input :disabled="options.condition.hitModel != 'ERVERTIME'" v-model:value="options.condition.hitInterval" class="w64"></a-input><span>小时再监测</span></a-space>
                </a-radio>
              </a-radio-group>
            </li>
          </ul>
        </div>
      </li>
      <li class="rule-module execution-order" v-if="false">
        <p class="module-title">顺序执行操作</p>
        <div class="module-content">
          <a-space :size="12" style="margin-bottom: 13px"> <a-button type="primary" @click="addRuleListItem(options.order)">新增规则</a-button> </a-space>
          <ul class="rule-list">
            <li class="rule-item" v-for="(rule, index) in options.order.ruleList" :key="rule">
              <RuleExecItem :options="ruleExecList" :rule="rule" :index="index" class="mr12"></RuleExecItem>
              <DeleteOutlined @click="deleteRuleListItem(options.order.ruleList, index)" v-show="options.condition.ruleList.length > 1" />
            </li>
            <li class="rule-item">
              <a-checkbox v-model:checked="options.order.checked">
                <a-space>
                  <span style="margin: 0 4px">执行次数至多</span>
                  <a-input v-model:value.number="options.order.intervalDays" type="number" class="w64" />
                  <span>天</span>
                  <a-input v-model:value.number="options.order.maxExecCount" type="number" class="w64" />
                  <span>次</span>
                </a-space>
              </a-checkbox>
            </li>
          </ul>
        </div>
      </li>
      <li class="rule-module notify-setting">
        <p class="module-title">通知设置</p>
        <div class="module-content">
          <ul class="rule-list">
            <li class="rule-item line-h32" style="margin-bottom: 20px">
              <a-space>
                <span class="rule-item-label">接收人</span>
                <a-checkbox-group v-model:value="options.notify.messageNotifyUser">
                  <!-- 暂时屏蔽 -->
                  <a-checkbox :value="1" v-if="options.range.level.value != 'CP'"> 账号主运营人员 </a-checkbox>
                  <!-- <a-checkbox :value="2"> 账号协作者 </a-checkbox> -->
                  <!-- <a-checkbox :value="3"> 产品负责人 </a-checkbox> -->
                  <!-- <a-checkbox v-show="options.range.level.value=='GG'" :value="5" class="association-post"> 该广告关联的素材后期 </a-checkbox> -->
                  <a-checkbox :value="4" class="specific-user" @change="options.notify.messageUser = []">
                    <span> 特定用户 </span>
                  </a-checkbox>
                </a-checkbox-group>
              </a-space>
              <SelectMultiple v-show="options.notify.messageNotifyUser.includes(4)" v-model:value="options.notify.messageUser" :select-data="options.notify.messageUser" :select-options="allUser" :allow-clear="true" mode="multiple" :label-in-value="true" placeholder="请选择用户" option-filter-prop="label" option-label-prop="label" :filter-option="true" :max-tag-count="1" :show-arrow="true" :dropdown-match-select-width="false" class="w176" />
            </li>
            <li class="rule-item">
              <a-space>
                <span class="rule-item-label">接收方式</span>
                <a-checkbox-group v-model:value="options.notify.messageType">
                  <a-checkbox value="FS">飞书</a-checkbox>

                  <a-checkbox value="YJ" v-if="options.notify.messageType.includes('YJ')">邮件</a-checkbox>
                  <a-popconfirm v-else title="请确认飞书是否完善邮箱信息，避免接收不到邮件" @confirm="options.notify.messageType.push('YJ')">
                    <a-checkbox value="YJ">邮件</a-checkbox>
                  </a-popconfirm>

                  <!-- 暂时屏蔽 -->
                  <!-- <a-checkbox value="DH">电话</a-checkbox> -->

                  <a-checkbox value="DX" v-if="options.notify.messageType.includes('DX')">短信</a-checkbox>
                  <a-popconfirm v-else title="请确认飞书是否完善手机号码，避免接收不到短信" @confirm="options.notify.messageType.push('DX')">
                    <a-checkbox value="DX">短信</a-checkbox>
                  </a-popconfirm>
                </a-checkbox-group>
              </a-space>
            </li>
            <li class="rule-item line-h32">
              <a-checkbox v-model:checked="options.notify.signChecked" @change="options.notify.signName = undefined">
                <span style="margin-right: 7px">标记</span>
                <a-input v-model:value="options.notify.signName" v-show="options.notify.signChecked" :maxlength="6" :suffix="`${options.notify.signName?.length ?? 0}/6`" class="w256" />
              </a-checkbox>
            </li>
          </ul>
        </div>
      </li>
      <li class="rule-module rule-name">
        <span class="rule-item-label"> 规则名称 </span>
        <a-input v-model:value="options.ruleName" style="width: 428px" :maxlength="50" :suffix="`${options.ruleName?.length ?? 0}/50`"> </a-input>
        <a-space class="float-r" :size="23">
          <a-button @click="showCustomizeRule.visible = false">取消</a-button>
          <a-button @click="handleOk" type="primary" :loading="btnLoading">确定</a-button>
        </a-space>
      </li>
    </ul>
  </div>
</template>

<script>
import { DeleteOutlined, CloseCircleFilled } from '@ant-design/icons-vue';
import CascaderSelect from './CascaderSelect.vue';
import SelectMultiple from '@/components/selectMultiple/index.vue';
import { getProductList, getAccountList, getCampaignList, getAdvertiseList, getRulesCondition, getRulesExec, saveOrUpdateRules } from '@/api/hosting/index.js';
import RuleConditionItem from './RuleConditionItem.vue';
import RuleExecItem from './RuleExecItem.vue';
import caliber from '@/components/Customize/caliber.vue';
export default {
  name: 'CustomizeRule',
  components: { caliber, RuleExecItem, RuleConditionItem, DeleteOutlined, CascaderSelect, CloseCircleFilled, SelectMultiple },
  props: {
    ruleOptions: { type: Object, default: null },
  },
  inject: ['showCustomizeRule', 'getActiveTemp', 'getAllUsers'],
  provide() {
    return {
      getHostingRange: () => this.options.range.level.value,
      getRuleConditionList: () => this.ruleConditionList,
    };
  },
  data() {
    return {
      options: {},
      ruleConditionList: [], //触发条件下拉数据
      ruleExecList: [], //执行规则下拉数据
      productLoadOver: false, //产品滚动加载是否完毕
      productList: [], //产品下拉数据
      selectedProjectList: [], //已选择的产品
      timer: null, //定时器

      tjkjList: [
        { key: 'REQUEST_TIME', title: '广告播放', details: ['转换数据统计至广告播放时间点', '适合场景:广告赔付考察、广告整体生命周期表现'] },
        { key: 'REPORTING_TIME', title: '转化回传', details: ['转换数据统计至行为上报时间点', '适合场景:实时查看当日上报数据情况'] },
      ],

      // 联级选择
      selectData1: [], //联级选择第一个下拉数据
      selectData2: [], //联级选择第二个下拉数据
      //联级选择第一个选定的数据
      selectedList1: [],
      //联级选择第二个选定的数据
      selectedList2: [],

      btnLoading: false,
    };
  },
  computed: {
    // 层级选择框配置
    levelOptions() {
      let options = [];
      switch (this.options?.range?.channel) {
        case 'GDT':
          options = [
            { label: '产品', value: 'CP' },
            { label: '账户', value: 'ZH' },
            { label: '推广计划', value: 'TGJH' },
            { label: '广告', value: 'GG' },
          ];
          break;
        case 'TT':
          options = [
            { label: '产品', value: 'CP' },
            { label: '账户', value: 'ZH' },
            { label: '广告组', value: 'TGJH' },
            { label: '计划', value: 'GG' },
          ];
          break;
        case 'KS':
          options = [
            { label: '产品', value: 'CP' },
            { label: '账户', value: 'ZH' },
            { label: '广告计划', value: 'TGJH' },
            { label: '广告组', value: 'GG' },
          ];
          break;
      }
      return {
        labelInValue: true,
        options,
      };
    },
    // 范围单选框文字
    rangeRadioText() {
      const obj = {
        CP: '产品',
        ZH: '账户',
        TGJH: '推广计划',
        GG: '广告',
      };
      return obj[this.options.range.level.value];
    },
    // 已选择的范围
    selectedList() {
      if (this.cascaderSelectPlaceholders[1] == '产品') {
        return this.selectedProjectList;
      } else if (this.cascaderSelectPlaceholders[1] == '账户') {
        return this.selectedList1;
      } else {
        return this.selectedList2;
      }
    },
    // 联级选择框placeholder
    cascaderSelectPlaceholders() {
      const obj = {
        CP: ['产品', '产品'],
        ZH: ['产品', '账户'],
        TGJH: ['账户', '推广计划'],
        GG: ['账户', '广告'],
      };
      return [obj[this.options.range.level.value][0], obj[this.options.range.level.value][this.options.range.levelWhere - 1]];
    },
    // 所有人员
    allUser() {
      return this.getAllUsers();
    },
  },
  watch: {
    'showCustomizeRule.visible': {
      async handler(val) {
        let options = null;
        if (this.showCustomizeRule.mode != 'add' && this.getActiveTemp?.() && this.getActiveTemp?.()?.id) {
          options = this.getActiveTemp();
        }
        if (val) {
          this.getoptions(options);
          this.getRulesCondition();
          this.getRulesExec();

          const res = await this.getProductList();
          const list = res.data?.list || [];
          this.productList.splice(0, 1000, ...list);
        }
      },
      immediate: true,
    },
    'selectedList.length'(val) {
      if (val == 100) {
        this.$message.warn('最多只能选择100个!');
      }
    },
  },
  methods: {
    // -------------------------------------------------------------------初始化及公共操作函数----------------------------------------------------------
    // 获取配置
    async getoptions(data) {
      const options = data || {};
      let condition = {};
      let execRange = {};
      // let execContent = null;
      // 屏蔽执行操作，目前默认传值仅通知
      let execContent = [{ field: 'no_operate', fieldName: '仅通知', referenceValue: 9 }];
      let messageNotifyUser = [];
      let messageUser = [];
      let messageType = [];
      if (data) {
        execRange = JSON.parse(data.execRange);
        condition = JSON.parse(data.condition);
        // execContent = JSON.parse(data.execContent);
        execContent = [{ field: 'no_operate', fieldName: '仅通知', referenceValue: 9 }];
        messageNotifyUser = JSON.parse(data.messageNotifyUser);
        messageUser = JSON.parse(data.messageUser)?.map(item => {
          return { value: item.userId, label: item.userName };
        });
        messageType = JSON.parse(data.messageType);
      }
      this.options = {
        // 托管范围
        range: {
          channel: options.channel || 'GDT',
          level: this.levelOptions.options.find(item => item.value == options.level) || { label: '产品', value: 'CP' },
          levelWhere: execRange.levelWhere || 1,
        },
        // 触发条件
        condition: {
          timeLine: { selectedKey: condition.timeLine || 'REPORTING_TIME', selectedValue: null },
          newItem: { field: null, fieldName: '', condition: undefined, targetField: null, targetFieldName: '', referenceValue: '', value: '', valueType: '', compareModel: null, orAnd: 'and' },
          ruleList: condition.info || [{ field: null, fieldName: '', condition: undefined, targetField: null, targetFieldName: '', referenceValue: '', value: '', valueType: '', compareModel: null, orAnd: 'and' }],
          startTime: options.startTime || '',
          endTime: options.endTime || '',
          monitoringDate: [options.startDate || '', options.endDate || ''],
          checkPeriod: Boolean(options.startTime),
          checkDate: Boolean(options.startDate),
          hitModel: options.hitModel || 'ONE',
          hitInterval: options.hitInterval || '',
        },
        // 顺序执行操作
        order: {
          newItem: { field: null, fieldName: '', referenceValue: '', valueType: '', limitValue: [] },
          ruleList: execContent || [{ field: null, fieldName: '', referenceValue: '', valueType: '', limitValue: [] }],
          checked: Boolean(options.maxExecCount),
          maxExecCount: options.maxExecCount,
          intervalDays: options.intervalDays,
        },
        // 通知设置
        notify: {
          messageNotifyUser,
          messageType,
          signName: options.signName,
          signChecked: Boolean(options.signName),
          messageUser,
        },
        // 规则名称
        ruleName: options.ruleName,
      };
      if (data) {
        // console.log({ data });
        if (this.showCustomizeRule.mode != 'add') {
          // 已选择产品
          this.selectedProjectList = execRange.selectedProjectList || [];

          if (execRange.selectData1.length) {
            // 联级下拉列表1数据
            await this.getAccountList();
            // 联级下拉列表1已选择数据
            this.selectedList1 = execRange.selectData1;

            if (execRange.info.length) {
              // 联级下拉列表2数据
              await this.getSelectData2(this.selectedList1[0]);
              // 联级下拉列表2已选择数据
              this.selectedList2 = execRange.info.map(item => ({ value: item.id, label: item.name }));
            }
          }
        }
        // 仅编辑的时候保留的的数据
        if (this.showCustomizeRule.mode == 'edit') {
          this.options.id = data.id;
          this.options.createUserId = data.createUserId;
          this.options.createUserName = data.createUserName;
        }
      }
    },
    // 获取所有触发条件
    async getRulesCondition() {
      const params = {
        channel: this.options.range.channel,
        level: this.options.range.level.value,
        limit: 500,
        page: 1,
      };
      const res = await getRulesCondition(params);
      const indicatorList = res.data?.list || [];
      indicatorList.forEach(indicator => {
        try {
          indicator.condition = JSON.parse(indicator.condition);
        } catch (error) {
          console.log(`id为${indicator.id}的触发条件json数据存在问题`, indicator);
        }
      });
      this.ruleConditionList?.splice(0, 1000, ...indicatorList);
    },
    // 获取所有执行操作
    async getRulesExec() {
      const params = {
        channel: this.options.range.channel,
        level: this.options.range.level.value,
        limit: 500,
        page: 1,
      };
      const res = await getRulesExec(params);
      const operationList = res.data?.list || [];
      operationList.forEach(operation => {
        try {
          operation.condition = JSON.parse(operation.condition);
        } catch (error) {
          console.log(`id为${operation.id}的执行操作json数据存在问题`, operation);
        }
      });
      this.ruleExecList.splice(0, 1000, ...operationList);
    },
    // 删除规则项
    deleteRuleListItem(list, index) {
      list.splice(index, 1);
    },
    // 新增规则项
    addRuleListItem(data) {
      const newItem = { ...data.newItem };
      if (data.ruleList?.[0]?.orAnd) {
        newItem.orAnd = data.ruleList[0].orAnd;
      }
      data.ruleList.push(newItem);
    },

    // -------------------------------------------------------------------托管范围----------------------------------------------------------
    levelWhereChange() {
      this.selectedList1.splice(0, 1000);
      this.selectedList2.splice(0, 1000);
    },
    // 懒加载产品列表
    async lazyLoadProduct() {
      const page = Math.ceil(this.productList.length / 30) + 1;
      const res = await this.getProductList(page);
      const list = res.data?.list || [];
      this.productList.splice(this.productList.length, 0, ...list);
      this.productLoadOver = page == res.data?.totalPage;
    },
    // 模糊搜索产品列表
    async searchProduct(inputValue) {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        const res = await this.getProductList(1, inputValue);
        const list = res.data?.list || [];
        this.productLoadOver = res.data?.totalPage < 2;
        this.productList.splice(0, this.productList.length, ...list);
      }, 300);
    },
    // 产品改变
    productChange() {
      this.selectedList1.splice(0, 1000);
      this.selectedList2.splice(0, 1000);
      this.selectData1.splice(0, 1000);
      this.selectData2.splice(0, 1000);
      this.getAccountList();
      if (this.selectedProjectList?.length == 100) {
        this.$message.warn('最多只能选择100个!');
        return;
      }
    },
    // 获取产品列表
    async getProductList(page, productName, init = false) {
      const obj = { isNotData: 1, timeLine: 'REPORTING_TIME', tempName: '自定义列表', page: page || 1, limit: 30, userId: 1 };
      if (productName) {
        obj.productName = productName;
      }
      const params = { ...obj };
      const res = await getProductList(params, this.options.range.channel);
      if (res.data?.list.length) {
        res.data.list.forEach((item, index) => {
          if (item.product_name == '未绑定产品') {
            res.data.list.splice(index, 1);
          }
        });
        if (init) {
          const list = res.data.list || [];
          this.productLoadOver = res.data?.totalPage < 2;
          this.productList.splice(0, this.productList.length, ...list);
        }
      }
      return res || {};
    },
    // 获取账户列表
    async getAccountList() {
      const productCodes = this.selectedProjectList.map(item => item.value);
      if (!productCodes.length || this.options.range.level.value == 'CP') {
        return;
      }
      const params = {
        page: 1,
        limit: 5000,
        channel: this.options.range.channel,
        level: this.options.range.level.value,
        productCodes,
      };
      const res = await getAccountList(params);
      const list = res.data?.list || [];
      if (list.length) {
        list.forEach(item => {
          item.value = item.id;
          item.label = item.name;
        });
      }
      this.selectData1.splice(0, 1000, ...list);
      return list;
    },
    // 获取推广计划列表
    async getCampaignList(arr) {
      const params = {
        page: 1,
        limit: 5000,
        channel: this.options.range.channel,
        level: this.options.range.level.value,
        advertiserIds: arr.map(item => item.value) || [],
      };
      const res = await getCampaignList(params, this.options.range.channel);
      const list = [];
      if (res.data?.list.length) {
        res.data.list.forEach(item => {
          if (item) {
            list.push({ value: item.id, label: item.name });
          }
        });
      }
      return list;
    },
    // 获取广告列表
    async getAdvertiseList(arr) {
      const params = {
        page: 1,
        limit: 5000,
        channel: this.options.range.channel,
        level: this.options.range.level.value,
        advertiserIds: arr.map(item => item.value) || [],
      };
      const res = await getAdvertiseList(params, this.options.range.channel);

      const list = [];
      if (res.data?.list.length) {
        res.data.list.forEach(item => {
          if (item) {
            list.push({ value: item.id, label: item.name });
          }
        });
      }
      return list;
    },
    // 媒体渠道改变
    async channelChange() {
      this.selectedProjectList.splice(0, 1000);
      this.selectedList1.splice(0, 1000);
      this.selectedList2.splice(0, 1000);
      this.selectData1.splice(0, 1000);
      this.selectData2.splice(0, 1000);
      this.options.condition.ruleList.splice(0, 100, { ...this.options.condition.newItem });

      this.getRulesExec();
      this.getRulesCondition();
      const res = await this.getProductList();
      const list = res.data?.list || [];
      this.productList.splice(0, 1000, ...list);
    },
    // 层级改变
    levelChange() {
      this.selectedProjectList.splice(0, 1000);
      this.selectedList1.splice(0, 1000);
      this.selectedList2.splice(0, 1000);
      this.selectData1.splice(0, 1000);
      this.selectData2.splice(0, 1000);
      this.options.condition.ruleList.splice(0, 100, { ...this.options.condition.newItem });

      this.getRulesExec();
      this.getRulesCondition();
      this.options.range.levelWhere = 1;
      this.getAccountList();
    },
    // 获取第二联级别的数据
    async getSelectData2(option) {
      const data = [option];
      let key = this.cascaderSelectPlaceholders[1];
      let list = [];
      switch (key) {
        case '推广计划':
          list = await this.getCampaignList(data);
          break;
        case '广告':
          list = await this.getAdvertiseList(data);
          break;
      }
      const arr = [];
      const selectedIds = this.selectedList2.map(item => item.value);
      list.forEach(item => {
        item.parentId = data[0].value;
        if (option.checked && !selectedIds.includes(item.id)) {
          arr.push(item);
        }
      });
      this.selectedList2.splice(this.selectedList2.length, 0, ...arr);
      this.selectData2.splice(0, 1000, ...list);
      option.spining && (option.spining.visible = false);
      return list;
    },
    // 删除已选择项
    deletSelectItem(index, number, data) {
      if (this.cascaderSelectPlaceholders[1] == '产品') {
        this.selectedProjectList.splice(index, number);
      } else if (this.cascaderSelectPlaceholders[1] == '账户') {
        this.selectedList1.splice(index, number);
      } else {
        this.selectedList2.splice(index, number);
        if (number == 10000) {
          this.selectedList1.splice(0, 10000);
        }
      }
    },
    // -------------------------------------------------------------------保存数据----------------------------------------------------------
    // 校验规则数据
    checkRuleData() {
      // 判断是否选中范围
      if (!this.selectedList.length) {
        this.$message.warn(`请选择${this.cascaderSelectPlaceholders[1]}！`);
        return false;
      }
      const flag = this.options.condition.ruleList.every(item => {
        return Array.from(item.requiredKey).every(([key, required]) => {
          return (required && item[key]) || !required;
        });
      });
      if (!flag) {
        this.$message.warn('请输入完整触发条件！');
        return false;
      }
      if (this.options.condition.checkPeriod) {
        if (!this.options.condition.startTime || !this.options.condition.endTime) {
          this.$message.warn('请输入完整的监测时段！');
          return false;
        }
      }
      if (this.options.condition.checkDate) {
        if (!this.options.condition.monitoringDate.length) {
          this.$message.warn('请输入完整的监测日期！');
          return false;
        }
      }
      if (this.options.condition.hitModel == 'ERVERTIME') {
        if (!this.options.condition.hitInterval) {
          this.$message.warn('请输入触发条件间隔时间！');
          return false;
        }
      }
      if (!this.options.order.ruleList[0]?.field) {
        this.$message.warn('请至少输入一条完整执行操作！');
        return false;
      }
      if (this.options.order.checked) {
        if (!this.options.order.intervalDays || !this.options.order.maxExecCount) {
          this.$message.warn('请输入完整的执行次数规则！');
          return false;
        }
      }
      if (this.options.notify.messageNotifyUser?.includes(4)) {
        if (!this.options.notify.messageUser.length) {
          this.$message.warn('请选择特定用户！');
          return false;
        }
      }
      if (this.options.notify.signChecked) {
        if (!this.options.notify.signName) {
          this.$message.warn('请输入标记名称！');
          return false;
        }
      }
      if (!this.options.ruleName) {
        this.$message.warn('请输入规则名称！');
        return false;
      }
      return true;
    },
    // 生成请求参数
    getParams() {
      const execRangeInfo = this.selectedList.map(item => {
        const obj = { id: item.value, name: item.label, code: item.value };
        return deleteNullKey(obj);
      });

      const conditionInfo = this.options.condition.ruleList.map(item => {
        const obj = {
          field: item.field,
          fieldName: item.fieldName,
          condition: item.condition,
          targetField: item.targetFieldName == '固定值' ? item.field : item.targetField,
          targetFieldName: item.targetFieldName == '固定值' ? item.fieldName : item.targetFieldName,
          referenceValue: item.targetFieldName == '固定值' ? 1 : item.referenceValue,
          value: item.value,
          valueType: item.valueType,
          compareModel: item.compareModel,
          orAnd: item.orAnd,
        };
        return deleteNullKey(obj);
      });
      const execContent = this.options.order.ruleList.map(item => {
        const obj = {
          field: item.field,
          fieldName: item.fieldName,
          referenceValue: item.referenceValue,
          valueType: item.valueType,
          limitValue: item.limitValue,
          limitType: item.limitType,
          value: item.value,
        };
        return deleteNullKey(obj);
      });
      let id = this.options.id;

      const params = {
        id,
        createUserId: this.options.createUserId ?? this.$store.state.oauth.userInfo.userId,
        createUserName: this.options.createUserName ?? this.$store.state.oauth.userInfo.userCode,
        // 规则名称
        ruleName: this.options.ruleName,
        // 范围
        level: this.options.range.level.value,
        channel: this.options.range.channel,
        execRange: {
          levelWhere: this.options.range.levelWhere,
          info: execRangeInfo,
          selectedProjectList: this.selectedProjectList,
          selectData1: this.cascaderSelectPlaceholders[1] == '账户' ? this.selectedList1 : this.selectData1.filter(item => item.checked || item.indeterminate),
        },
        // 条件
        condition: {
          timeLine: this.options.condition.timeLine.selectedKey,
          info: conditionInfo,
        },
        startTime: this.options.condition.checkPeriod ? this.options.condition.startTime : null,
        endTime: this.options.condition.checkPeriod ? this.options.condition.endTime : null,
        startDate: this.options.condition.checkDate ? this.options.condition.monitoringDate[0] : null,
        endDate: this.options.condition.checkDate ? this.options.condition.monitoringDate[1] : null,
        hitModel: this.options.condition.hitModel,
        hitInterval: this.options.condition.hitModel == 'ERVERTIME' ? this.options.condition.hitInterval : null,
        // 操作执行顺序
        execContent: JSON.stringify(execContent),
        intervalDays: this.options.order.checked ? this.options.order.intervalDays : null,
        maxExecCount: this.options.order.checked ? this.options.order.maxExecCount : null,
        // 通知设置
        messageNotifyUser: JSON.stringify(this.options.notify.messageNotifyUser),
        messageUser: this.options.notify.messageNotifyUser.includes(4) ? JSON.stringify(this.options.notify.messageUser.map(item => ({ userId: item.value, userName: item.label }))) : null,
        messageType: JSON.stringify(this.options.notify.messageType),
        signName: this.options.notify.signChecked ? this.options.notify.signName : null,
      };
      function deleteNullKey(obj) {
        Object.keys(obj).forEach(key => {
          if (Array.isArray(obj[key]) && !obj[key].length) {
            delete obj[key];
          } else if (!obj[key]) {
            delete obj[key];
          }
        });
        return obj;
      }
      return deleteNullKey(params);
    },
    // 点击确定
    async handleOk() {
      // 校验规则数据
      const flag = this.checkRuleData();
      if (!flag) return;
      this.btnLoading = true;
      const params = this.getParams();
      // console.log('params', params);
      const res = await saveOrUpdateRules(params);

      if (res.code == 0) {
        this.$message.success(`${this.showCustomizeRule.mode == 'edit' ? '编辑' : '新建'}成功`);
        this.showCustomizeRule.visible = false;
        this.showCustomizeRule.refresh = true;
      } else {
        this.$message.error('操作失败，请重试');
      }
      this.btnLoading = false;
    },

    // -------------------------------------------------------------------触发条件----------------------------------------------------------
    // 口径下拉变化
    onTJKJSelect(item, checked) {
      checked && (item = 'ACTIVE_TIME');
      const selectedValue = this.tjkjList.find(tjkj => tjkj.key == item)?.title || '转化回传激活';
      this.options.condition.timeLine = { selectedKey: item, selectedValue };
      //请求数据
    },
  },
};
</script>

<style scoped lang="less">
.customize-rule-wrapper {
  background: rgb(240, 242, 245);
  display: flex;
  flex-direction: column;
  font-size: 12px;
  .rule-header {
    height: 36px;
    .header-text {
      line-height: 24px;
      font-weight: 500;
      font-size: 16px;
      color: #2f70f4;
    }
  }
  .rule-body {
    height: 200px;
    flex-grow: 1;
    border-radius: 8px;
    padding-right: 7px;
    overflow-y: auto;
    .rule-module {
      border-radius: 8px;
      background: #fff;
      .module-title {
        height: 45px;
        line-height: 45px;
        border-bottom: 1px solid rgb(245, 247, 250);
        color: #333;
        font-size: 14px;
        &::before {
          content: '';
          display: inline-block;
          height: 12px;
          width: 4px;
          background-color: #2f70f4;
          margin-right: 10px;
          transform: translateY(1px);
        }
      }
      .module-content {
        padding: 12px 15px;
        .rule-list {
          .rule-item:not(:last-child) {
            margin-bottom: 24px;
          }
          :deep(.select-multiple) .ant-select-selection-item {
            max-width: calc(100% - 80px) !important;
          }
        }
      }
      &:not(:first-child) {
        margin-top: 12px;
      }
      &.hosting-range {
        .all-selected-wrapper {
          border-radius: 4px;
          border: 1px solid #e6e9f1;
          .select-filter {
            padding: 13px;
            overflow: hidden;
            .ant-radio-group {
              margin: 23px 0 20px 0;
              display: block;
            }
          }
          .all-selected {
            background: #f9f9f9;
            display: flex;
            padding: 16px 0 4px 0;
            .selected-number {
              width: 90px;
              padding-left: 12px;
            }
            .all-selected-list {
              width: calc(100% - 139px);
              height: 100%;
              display: flex;
              flex-wrap: wrap;
              .all-selected-item {
                border-radius: 4px;
                background: #fff;
                border: 1px solid #e6e9f1;
                padding: 7px 9px;
                position: relative;
                margin-bottom: 12px;
                margin-right: 12px;
                p {
                  line-height: 16px;
                  color: #333;
                  &.id {
                    color: #ababab;
                  }
                }
                .delete-icon {
                  position: absolute;
                  right: -6px;
                  top: -6px;
                  cursor: pointer;
                  z-index: 2;
                  color: #5e5e5e;
                }
              }
            }
            .clear-all {
              color: #929292;
              cursor: pointer;
              width: 40px;
              margin: 0 9px;
              height: 25px;
              text-align: center;
              &:hover {
                background: rgb(240, 242, 245);
                color: black;
                cursor: pointer;
              }
            }
          }
        }
      }
      &.trigger-condition {
        .rule-list .rule-item:first-child .radio-group {
          margin-left: 76px;
        }
      }
      &.notify-setting {
        .rule-item:not(:last-child) {
          .rule-item-label {
            display: inline-block;
            width: 110px;
            font-weight: bold;
          }
          :deep(.ant-checkbox-group) {
            .ant-checkbox-wrapper {
              // 暂时屏蔽而更改的样式
              width: 185px;
              &.specific-user {
                width: 85px;
              }
            }
          }
        }
      }
      &.rule-name {
        height: 54px;
        line-height: 54px;
        padding-right: 24px;
        .rule-item-label {
          font-weight: bold;
          margin: 0 7px 0 12px;
        }
      }
      .rule-item-label {
        color: #333;
        font-size: 12px;
      }
    }

    :deep(.ant-time-picker-input),
    :deep(.ant-calendar-picker-input),
    :deep(.ant-select-selector) {
      height: 30px !important;
      // padding: 0 11px;
    }
    :deep(.ant-select-multiple) .ant-select-selector {
      padding: 0 4px;
    }
  }
}
</style>
<style lang="less">
.w64 {
  width: 64px;
}
.w120 {
  width: 120px;
}
.w176 {
  width: 176px;
}
.w256 {
  width: 256px;
}
.mr12 {
  margin-right: 12px;
}
.line-h32 {
  line-height: 32px;
}
</style>
